import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import promoColors from 'theme/promoColors';

const defaultSize = '100%';
const defaultThickness = '2';

const Container = styled.span`
    display: inline-block;
    height: ${(props) => (props.size ? props.size : defaultSize)};
    margin-right: ${(props) => (props.rightIndent ? props.rightIndent : null)};
    margin-left: ${(props) => (props.leftIndent ? props.leftIndent : null)};

    svg {
        width: ${(props) => (props.size ? props.size : defaultSize)};
        height: ${(props) => (props.size ? props.size : defaultSize)};
        --accent: ${(props) => promoColors[props.color]};
        --thickness: ${(props) => (props.thickness ? props.thickness : defaultThickness)};
    }
`;

function renderSVG({ id }) {
    return (
        <svg>
            <use xlinkHref={`/i/promo-svg-icons/promo-icons.svg#${id}`} />
        </svg>
    );
}

const StyledSVGIcon = styled(renderSVG)`
    display: inline-block;
`;

export const PromoIcon = (props) => {
    return (
        <Container rightIndent={props.rightIndent} leftIndent={props.leftIndent} color={props.color} size={props.size}>
            <StyledSVGIcon id={props.name} />
        </Container>
    );
};

PromoIcon.propTypes = {
    name: PropTypes.string,
    color: PropTypes.oneOf([
        'baseColor',
        'primary',
        'primaryB2B',
        'purple80',
        'purple40',
        'purple20',
        'purple5',
        'gray80',
        'gray40',
        'gray20',
        'gray5',
        'white',
        'error',
        'success',
        'sunflower',
        'cyan',
        'lavender',
        'turquoise',
    ]),
    size: PropTypes.oneOf(['16px', '24px', '64px', '80px', '100%']),
    thickness: PropTypes.string, // толщина линии свгшки (stroke)
    rightIndent: PropTypes.oneOf(['4px', '8px', '12px', '16px', '24px', '32px']),
    leftIndent: PropTypes.oneOf(['4px', '8px', '12px', '16px', '24px', '32px']),
};
